<table class="w-full mb-5">
    <thead class="text-black dark:text-white">
        <tr>
            <th class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tl-md">
                <!-- i18n: Description -->
                {{ 'i18n.app.features.pages.order.wizard.step_01.summary.table.th_01' | translate }}
            </th>
            <th class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tl-md">
                <!-- i18n: Rate -->
                {{ 'i18n.app.features.pages.order.wizard.step_01.summary.table.th_02' | translate }}
            </th>
            <th class="font-medium ltr:text-right rtl:text-left px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tl-md">
                <!-- i18n: Price -->
                {{ 'i18n.app.features.pages.order.wizard.step_01.summary.table.th_03' | translate }}
            </th>
        </tr>
    </thead>
    <tbody class="text-black dark:text-white">
            @let currencyPurchaseList = _orderWizardService.orderWizard$()?.step01?.currencyPurchaseList;
            @for(currencyPurchase of currencyPurchaseList; ; track $index; let i = $index) {
            <tr>
                <td class="flex items-center gap-2 text-gray-500 text-sm dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l">
                    <span>
                        <!-- i18n: Purchase -->
                        {{ 'i18n.app.features.pages.order.wizard.step_01.summary.table.span_01' | translate }}
                    </span>
                    <img class="h-5 w-5" [src]="currencyPurchase.targetCurrency?.imgPath" alt="" />
                    <span>{{currencyPurchase.targetAmount}}</span>
                    <span class="relative group inline-flex items-center gap-1 ml-1">
                        <!-- Chip -->
                        <span class="px-2 py-0.5 rounded-full text-white bg-secondary-600 dark:bg-gray-700 text-xs font-medium cursor-pointer">
                              {{currencyPurchase.targetCurrency?.code}}
                        </span>
                        <!-- Tooltip -->
                        <span 
                            class="absolute bottom-full mb-2 hidden group-hover:block 
                                    bg-black text-white text-xs rounded px-2 py-1 whitespace-nowrap">
                            {{currencyPurchase.targetCurrency?.label}}
                        </span>
                    </span>

                </td>
                <td class="text-gray-500 text-sm dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l">
                    {{ currencyPurchase.targetCurrency?.sellRate }}
                </td>
                <td class="text-gray-500 text-sm dark:text-gray-400 ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l">
                    €{{ currencyPurchase.sourceAmount }}
                </td>
            </tr>
            }
        <tr>
            <td colspan="2" class="text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l">
                <!-- i18n: Sub Total : -->
                {{ 'i18n.app.features.pages.order.wizard.step_01.summary.table.td_01' | translate }}
            </td>
            <td class="text-gray-500 dark:text-gray-400 ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l">
                €{{ _orderWizardService.orderWizard$()?.step01?.pricingSummary?.subTotal }}
            </td>
        </tr>

        <tr>
            <td colspan="2" class="text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l">
                <!-- i18n: Fees: -->
                {{ 'i18n.app.features.pages.order.wizard.step_01.summary.table.td_02' | translate }}
            </td>
            <td class="text-gray-500 dark:text-gray-400 ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l">
                €{{ _orderWizardService.orderWizard$()?.step01?.pricingSummary?.serviceFee }}
            </td>
        </tr>
        
        <tr>
            <td colspan="2" class="font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l">
                <!-- i18n: Total: -->
                {{ 'i18n.app.features.pages.order.wizard.step_01.summary.table.td_03' | translate }}
            </td>
            <td class="text-lg font-semibold ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l">
                €{{ _orderWizardService.orderWizard$()?.step01?.pricingSummary?.total }}
            </td>
        </tr>
    </tbody>
</table>